import { Col, Grid, Typography } from "antd";
import styled, { css } from "styled-components";

export const InfoText = styled(Typography.Text)`
  font-size: 1rem;
  text-transform: uppercase !important;
`;

export const LabelText = styled(InfoText)`
  font-weight: bold;
  margin-right: 1rem;
`;

export const ColFullWidth = styled(Col).attrs<{ $firstLine: boolean }>({
  span: 24,
})`
  padding: 1rem 0.5rem;
  border-bottom: 1.5px solid #000;
  vertical-align: middle;
  ${(props) => (props.$firstLine ? "border-top: 1.5px solid #000;" : "")}
`;

const headerCss = css`
  margin-top: 2rem;
  z-index: 10;
`;
export const H1JobTitle = styled(Typography.Title).attrs<{
  $breakpoints: ReturnType<typeof Grid.useBreakpoint>;
}>({
  level: 1,
})`
  ${headerCss}
  position: relative;
  font-size: ${(props) =>
    props.$breakpoints.lg ? "3.875rem" : "3rem"} !important;
  font-weight: 800 !important;
  max-width: 60rem;
  margin: auto;
`;

export const H2ApplyTitle = styled(Typography.Title).attrs<{
  $breakpoints: ReturnType<typeof Grid.useBreakpoint>;
}>({
  level: 2,
})`
  ${headerCss}
  color: #000;
  font-size: 1.5rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.0375rem;
  line-height: 1.5rem !important;
  margin-bottom: 0.5rem;
  font-family: trade-gothic-next, arial, sans-serif !important;
`;

export const StyledLabel = styled(Typography.Text).attrs({ strong: true })`
  letter-spacing: 0.08438rem !important;
  text-transform: uppercase !important;
`;

export const RichTextContainer = styled.div`
  h1,
  h2,
  h3,
  h4 {
    color: #000;
    font-size: 1.5rem !important;
    font-weight: 800 !important;
    letter-spacing: 0.0375rem !important;
    line-height: 1.5rem !important;
    margin-bottom: 0.5rem !important;
    font-family: trade-gothic-next, arial, sans-serif !important;
  }
  p {
    color: #000;
    font-size: 0.9375rem !important;
    font-weight: 400 !important;
    line-height: 1.375rem !important;
    margin-bottom: 1rem !important;

    strong {
      font-weight: bold !important;
    }
  }
  strong {
    font-weight: 800 !important;
  }
  li {
    strong {
      font-weight: bold !important;
    }
  }
  ul,
  ol {
    margin-bottom: 1rem !important;
  }
`;
